'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDateTextFromGroup = getDateTextFromGroup;
exports.getUrlFromGroup = getUrlFromGroup;
exports.makeGroupedChatHistory = makeGroupedChatHistory;

var _immutable = require('immutable');

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _RoleTypes = require('conversations-schema/constants/RoleTypes');

var _RoleTypes2 = _interopRequireDefault(_RoleTypes);

var _PubNubMessageModel = require('conversations-schema/models/PubNubMessageModel');

var _ConversationalMessageModel = require('conversations-schema/models/ConversationalMessageModel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDateTextFromGroup(group) {
  var firstMessage = group.first();
  var timestamp = (0, _PubNubMessageModel.getTimestamp)(firstMessage);
  return _I18n2.default.moment(timestamp).format('MMMM DD');
}

function getUrlFromGroup(group) {
  var visitorMessages = group.filter(function (message) {
    return (0, _ConversationalMessageModel.getFrom)(message) === _RoleTypes2.default.VISITOR;
  });
  var firstMessage = visitorMessages.first();
  return (0, _ConversationalMessageModel.getUrl)(firstMessage);
}

function areFromSameSender(messageA, messageB) {
  return (0, _ConversationalMessageModel.getFrom)(messageA) === (0, _ConversationalMessageModel.getFrom)(messageB);
}

function areWithinOneMinute(messageA, messageB) {
  var roundedMomentA = _I18n2.default.moment((0, _PubNubMessageModel.getTimestamp)(messageA)).startOf('minute');
  var roundedMomentB = _I18n2.default.moment((0, _PubNubMessageModel.getTimestamp)(messageB)).startOf('minute');

  return roundedMomentA.isSame(roundedMomentB);
}

function groupMessages(list) {
  var groups = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _immutable.List)([(0, _immutable.List)()]);

  if (list.size === 0) {
    return groups;
  }

  var listHead = list.first();
  var nextList = list.shift();

  var groupsTail = groups.last();
  var firstInTail = groupsTail.first();
  var nextGroups = groups.pop();

  var shouldAddToLastGroup = groupsTail.size === 0 || areFromSameSender(listHead, firstInTail) && areWithinOneMinute(listHead, firstInTail);

  var groupsToPass = shouldAddToLastGroup ? nextGroups.push(groupsTail.push(listHead)) : nextGroups.push(groupsTail, (0, _immutable.List)([listHead]));

  return groupMessages(nextList, groupsToPass);
}

function makeGroupedChatHistory(historySet) {
  var historyList = historySet.toList();

  return groupMessages(historyList);
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.133/js/utils/chatHistoryGroups.js
// module id = 410
// module chunks = 0 1